import { createWebHistory, createRouter } from "vue-router";

const routes = [
  {
    path: "/",
    name: "index",
    component: () => import('@/pages/Inicio.vue'),
  },
  {
    path: "/sobre-nos",
    name: "sobre-nos",
    component: () => import('@/pages/SobreNos.vue'),
  },
  {
    path: "/contate-nos",
    name: "contate-nos",
    component: () => import('@/pages/ContateNos.vue'),
  },
  {
    path: "/produtos",
    name: "produtos",
    component: () => import('@/pages/ListaProdutos.vue'),
  },
  {
    path: "/produtos/:id",
    name: "detalhes-produtos",
    component: () => import('@/pages/DetalhesProduto.vue'),
  },
  {
    path: "/:error(.*)",
    name: "error",
    component: () => import('@/pages/special-pages/error.vue'),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;